/**
 * Users Hooks
 * React Query hooks for user listing operations
 */

import { useQuery } from '@tanstack/react-query';
import { usersApi, type UsersQueryParams } from '@/lib/api/users';
import type { UsersListResponse } from '@/types/users';

/**
 * Query users for selection/targeting
 * @param params.search - Search by name or user_id
 * @param params.has_token - Only return users with active push tokens (default: false)
 * @param params.page - Page number (1-based)
 * @param params.limit - Items per page (max: 100)
 */
export function useUsers(params?: UsersQueryParams): ReturnType<typeof useQuery<UsersListResponse>> {
  return useQuery({
    queryKey: ['users', 'list', params],
    queryFn: () => usersApi.getUsers(params),
  });
}
